import { CommonModule } from '@angular/common'
import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnDestroy,
  OnInit,
} from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatSnackBar } from '@angular/material/snack-bar'
import { DocumentTypeModel, FileService } from '@mmx/shared'
import { TranslateModule, TranslateService } from '@ngx-translate/core'
import { Subject, takeUntil } from 'rxjs'

@Component({
  selector: 'mmx-document-type-dialog',
  templateUrl: './document-type-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    TranslateModule,
    CommonModule,
    FlexLayoutModule,
    ReactiveFormsModule,
    MatIconModule,
    MatDialogModule,
    MatInputModule,
    MatButtonModule,
  ],
})
export class CreateOrEditDocumentTypeDialogComponent implements OnInit, OnDestroy {

  public formGroup = this.fb.group({
    label: this.fb.control<string>(null, {
      validators: Validators.required,
    }),
  })

  private onDestroy$ = new Subject<void>()
  public existingDocumentType: DocumentTypeModel
  public oldName: string

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { existingDocumentType: DocumentTypeModel },
    public fileService: FileService, //Service,
    public dialogRef: MatDialogRef<CreateOrEditDocumentTypeDialogComponent>,
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
    private fb: FormBuilder,
  ) {}

  ngOnInit() {
    this.existingDocumentType = this.data?.existingDocumentType
    if (this.existingDocumentType) {
      this.oldName = this.existingDocumentType?.label
      this.formGroup.controls.label.setValue(this.existingDocumentType.label)
    }
  }

  onSaveClick() {
    const updatedType = new DocumentTypeModel({ ...(this.existingDocumentType?.toJSON() || {}) })
    updatedType.label = this.formGroup.value.label
    this.fileService
      .upsertDocumentType(updatedType)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe({
        next: () => {
          this.snackBar.open(this.translateService.instant(
            this.existingDocumentType?.id ? 'document.document-type-updated' : 'document.document-type-created',
            { label: this.formGroup.value?.label }), null, { duration: 3000 })
          this.dialogRef.close()
        },
      })
  }

  public ngOnDestroy() {
    this.onDestroy$.next()
    this.onDestroy$.complete()
  }
}
